export const kidsAccessories = [
    {   
        id: 0,
        name: 'Ducky bag',
        price: 6.99,
        image: './asset/kid-accessories.png'
    },  
    {
        id: 1,
        name: 'Froggy bag',
        price: 6.99,
        image: './asset/kid-accessories1.png'
    },
    {
        id: 2,
        name: 'Bus-sy bag',
        price: 6.99,
        image: './asset/kid-accessories2.png'
    },
    {
        id: 3,
        name: 'Quality black',
        price: 9.99,
        image: './asset/kid-accessories3.png'
    },
    {
        id: 4,
        name: 'Quality silver',
        price: 9.99,
        image: './asset/kid-accessories4.png'
    },
    {
        id: 5,
        name: 'Stripe red',
        price: 4.99,
        image: './asset/kid-accessories5.png'
    },
    {
        id: 6,
        name: 'Stripe white',
        price: 4.99,
        image: './asset/kid-accessories6.png'
    },
    {
        id: 7,
        name: 'Stripe black',
        price: 4.99,
        image: './asset/kid-accessories7.png'
    },
    ]